module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"}
// module id = 7
// module chunks = 0